// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html[data-modal-background-locked],
html[data-modal-background-locked] body {
  overflow: hidden !important;
  overscroll-behavior: none;
}

html[data-modal-background-locked] :is(
  .dashboard-nav,
  .dashboard-overlay,
  .dashboard-sidebar-launcher,
  .app-topbar,
  .MuiDrawer-docked
) {
  z-index: 90 !important;
  filter: blur(2px);
  pointer-events: none !important;
}

/* RCTI review and document preview cover only the workspace, not navigation. */
html[data-modal-background-locked][data-rcti-workspace-open] .dashboard-nav {
  z-index: 9999 !important;
  filter: none !important;
  pointer-events: auto !important;
}
html[data-modal-background-locked][data-rcti-workspace-open] .dashboard-overlay {
  z-index: 9998 !important;
  filter: none !important;
  pointer-events: auto !important;
}
html[data-modal-background-locked][data-rcti-workspace-open] .app-topbar {
  z-index: 1501 !important;
  filter: none !important;
  pointer-events: auto !important;
}
html[data-modal-background-locked][data-rcti-workspace-open] .dashboard-sidebar-launcher {
  z-index: 9998 !important;
  filter: none !important;
  pointer-events: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/modalBackground.css"],"names":[],"mappings":"AAAA;;EAEE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,+EAA+E;AAC/E;EACE,wBAAwB;EACxB,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,+BAA+B;AACjC","sourcesContent":["html[data-modal-background-locked],\nhtml[data-modal-background-locked] body {\n  overflow: hidden !important;\n  overscroll-behavior: none;\n}\n\nhtml[data-modal-background-locked] :is(\n  .dashboard-nav,\n  .dashboard-overlay,\n  .dashboard-sidebar-launcher,\n  .app-topbar,\n  .MuiDrawer-docked\n) {\n  z-index: 90 !important;\n  filter: blur(2px);\n  pointer-events: none !important;\n}\n\n/* RCTI review and document preview cover only the workspace, not navigation. */\nhtml[data-modal-background-locked][data-rcti-workspace-open] .dashboard-nav {\n  z-index: 9999 !important;\n  filter: none !important;\n  pointer-events: auto !important;\n}\nhtml[data-modal-background-locked][data-rcti-workspace-open] .dashboard-overlay {\n  z-index: 9998 !important;\n  filter: none !important;\n  pointer-events: auto !important;\n}\nhtml[data-modal-background-locked][data-rcti-workspace-open] .app-topbar {\n  z-index: 1501 !important;\n  filter: none !important;\n  pointer-events: auto !important;\n}\nhtml[data-modal-background-locked][data-rcti-workspace-open] .dashboard-sidebar-launcher {\n  z-index: 9998 !important;\n  filter: none !important;\n  pointer-events: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
